export { matchers } from './matchers.js';

export const nodes = [
	() => import('./nodes/0'),
	() => import('./nodes/1'),
	() => import('./nodes/2'),
	() => import('./nodes/3'),
	() => import('./nodes/4'),
	() => import('./nodes/5'),
	() => import('./nodes/6'),
	() => import('./nodes/7'),
	() => import('./nodes/8'),
	() => import('./nodes/9'),
	() => import('./nodes/10'),
	() => import('./nodes/11'),
	() => import('./nodes/12'),
	() => import('./nodes/13'),
	() => import('./nodes/14'),
	() => import('./nodes/15'),
	() => import('./nodes/16'),
	() => import('./nodes/17'),
	() => import('./nodes/18'),
	() => import('./nodes/19'),
	() => import('./nodes/20'),
	() => import('./nodes/21'),
	() => import('./nodes/22'),
	() => import('./nodes/23'),
	() => import('./nodes/24'),
	() => import('./nodes/25'),
	() => import('./nodes/26'),
	() => import('./nodes/27'),
	() => import('./nodes/28'),
	() => import('./nodes/29'),
	() => import('./nodes/30'),
	() => import('./nodes/31'),
	() => import('./nodes/32'),
	() => import('./nodes/33'),
	() => import('./nodes/34'),
	() => import('./nodes/35'),
	() => import('./nodes/36'),
	() => import('./nodes/37'),
	() => import('./nodes/38'),
	() => import('./nodes/39'),
	() => import('./nodes/40'),
	() => import('./nodes/41'),
	() => import('./nodes/42'),
	() => import('./nodes/43'),
	() => import('./nodes/44'),
	() => import('./nodes/45'),
	() => import('./nodes/46'),
	() => import('./nodes/47'),
	() => import('./nodes/48'),
	() => import('./nodes/49'),
	() => import('./nodes/50'),
	() => import('./nodes/51'),
	() => import('./nodes/52'),
	() => import('./nodes/53'),
	() => import('./nodes/54'),
	() => import('./nodes/55'),
	() => import('./nodes/56'),
	() => import('./nodes/57'),
	() => import('./nodes/58'),
	() => import('./nodes/59'),
	() => import('./nodes/60'),
	() => import('./nodes/61'),
	() => import('./nodes/62'),
	() => import('./nodes/63'),
	() => import('./nodes/64'),
	() => import('./nodes/65'),
	() => import('./nodes/66'),
	() => import('./nodes/67'),
	() => import('./nodes/68'),
	() => import('./nodes/69'),
	() => import('./nodes/70'),
	() => import('./nodes/71'),
	() => import('./nodes/72'),
	() => import('./nodes/73'),
	() => import('./nodes/74'),
	() => import('./nodes/75'),
	() => import('./nodes/76'),
	() => import('./nodes/77'),
	() => import('./nodes/78'),
	() => import('./nodes/79'),
	() => import('./nodes/80'),
	() => import('./nodes/81'),
	() => import('./nodes/82'),
	() => import('./nodes/83'),
	() => import('./nodes/84'),
	() => import('./nodes/85'),
	() => import('./nodes/86'),
	() => import('./nodes/87'),
	() => import('./nodes/88'),
	() => import('./nodes/89'),
	() => import('./nodes/90'),
	() => import('./nodes/91'),
	() => import('./nodes/92'),
	() => import('./nodes/93'),
	() => import('./nodes/94'),
	() => import('./nodes/95'),
	() => import('./nodes/96'),
	() => import('./nodes/97'),
	() => import('./nodes/98'),
	() => import('./nodes/99'),
	() => import('./nodes/100'),
	() => import('./nodes/101'),
	() => import('./nodes/102'),
	() => import('./nodes/103'),
	() => import('./nodes/104'),
	() => import('./nodes/105'),
	() => import('./nodes/106'),
	() => import('./nodes/107'),
	() => import('./nodes/108'),
	() => import('./nodes/109'),
	() => import('./nodes/110'),
	() => import('./nodes/111'),
	() => import('./nodes/112'),
	() => import('./nodes/113'),
	() => import('./nodes/114'),
	() => import('./nodes/115'),
	() => import('./nodes/116')
];

export const server_loads = [2,18,21];

export const dictionary = {
		"/(app)/(anonymous)": [~22,[2,3]],
		"/(app)/(connected)/(app)/admin": [29,[2,5,6,7]],
		"/(app)/(connected)/(app)/admin/business/[hash]": [30,[2,5,6,7,8]],
		"/(app)/(connected)/(app)/admin/business/[hash]/billing-settings": [31,[2,5,6,7,8]],
		"/(app)/(connected)/(app)/admin/business/[hash]/features": [32,[2,5,6,7,8]],
		"/(app)/(connected)/(app)/admin/socket": [33,[2,5,6,7]],
		"/(app)/(connected)/(app)/dashboard": [34,[2,5,6]],
		"/(app)/(connected)/(app)/dashboard/billing/contract": [35,[2,5,6]],
		"/(app)/(connected)/(app)/dashboard/billing/invoices": [36,[2,5,6]],
		"/(app)/(connected)/(app)/dashboard/billing/payment-method": [37,[2,5,6]],
		"/(app)/(connected)/(app)/dashboard/billing/upgrade": [38,[2,5,6]],
		"/(app)/(connected)/(app)/dashboard/calendar": [39,[2,5,6,9]],
		"/(app)/(connected)/(app)/dashboard/calendar/booking/new": [41,[2,5,6,9,10]],
		"/(app)/(connected)/(app)/dashboard/calendar/booking/[id]": [40,[2,5,6,9,10]],
		"/(app)/(connected)/(app)/dashboard/calendar/date/[date]": [42,[2,5,6,9]],
		"/(app)/(connected)/(app)/dashboard/customers": [43,[2,5,6]],
		"/(app)/(connected)/(app)/dashboard/giftcards": [44,[2,5,6]],
		"/(app)/(connected)/(app)/dashboard/giftcards/online": [45,[2,5,6]],
		"/(app)/(connected)/(app)/dashboard/payment": [46,[2,5,6]],
		"/(app)/(connected)/(app)/dashboard/payment/setup": [47,[2,5,6]],
		"/(app)/(connected)/(app)/dashboard/payment/setup/redirect": [48,[2,5,6]],
		"/(app)/(connected)/(app)/dashboard/payment/transactions": [49,[2,5,6]],
		"/(app)/(connected)/(app)/dashboard/reviews": [50,[2,5,6]],
		"/(app)/(connected)/(app)/dashboard/support": [51,[2,5,6]],
		"/debug/(dev)": [80,[16]],
		"/debug/(dev)/colors": [81,[16]],
		"/debug/(dev)/emptyPage": [82,[16]],
		"/debug/(prod)/error": [88],
		"/debug/(dev)/pushState": [83,[16]],
		"/debug/(dev)/richTextArea": [84,[16]],
		"/debug/(dev)/test/byebye": [85,[16]],
		"/debug/(dev)/test/page/new": [87,[16]],
		"/debug/(dev)/test/page/[id]": [86,[16]],
		"/emails/transactional": [89,[17]],
		"/(app)/logout": [78,[2]],
		"/(app)/(connected)/onboarding": [69,[2,5,13]],
		"/(app)/(connected)/onboarding/_legacy": [75,[2,5,13]],
		"/(app)/(connected)/onboarding/(start)/inventory": [70,[2,5,13,14]],
		"/(app)/(connected)/onboarding/(start)/offers": [71,[2,5,13,14]],
		"/(app)/(connected)/onboarding/(start)/opening-hours": [72,[2,5,13,14]],
		"/(app)/(connected)/onboarding/(start)/profile": [73,[2,5,13,14]],
		"/(app)/(connected)/onboarding/(start)/public": [74,[2,5,13,14]],
		"/(app)/(connected)/onboarding/terms": [76,[2,5,13]],
		"/(app)/(connected)/onboarding/widget": [77,[2,5,13]],
		"/(app)/(anonymous)/(t-c)/privacy": [24,[2,3,4]],
		"/(app)/qr-code/[token]/[date]": [79,[2,15]],
		"/(app)/(anonymous)/recover-password/[token]": [26,[2,3]],
		"/(app)/(anonymous)/redirect/collect-payment": [27,[2,3]],
		"/(app)/(anonymous)/registration": [28,[2,3]],
		"/(app)/(anonymous)/(landing)/resevation-en-ligne-entrepeneur-tpe-artisan": [~23,[2,3]],
		"/(app)/(connected)/(app)/settings/(simple)": [52,[2,5,6,11]],
		"/(app)/(connected)/(app)/settings/activity": [60,[2,5,6]],
		"/(app)/(connected)/(app)/settings/activity/[id]": [61,[2,5,6]],
		"/(app)/(connected)/(app)/settings/communication": [62,[2,5,6]],
		"/(app)/(connected)/(app)/settings/communication/email-appearance": [63,[2,5,6]],
		"/(app)/(connected)/(app)/settings/communication/email-content": [64,[2,5,6]],
		"/(app)/(connected)/(app)/settings/custom-fields": [65,[2,5,6]],
		"/(app)/(connected)/(app)/settings/custom-fields/[id]": [66,[2,5,6]],
		"/(app)/(connected)/(app)/settings/(simple)/(pages)/inventory": [53,[2,5,6,11,12]],
		"/(app)/(connected)/(app)/settings/(simple)/(pages)/notifications": [54,[2,5,6,11,12]],
		"/(app)/(connected)/(app)/settings/(simple)/(pages)/offers": [55,[2,5,6,11,12]],
		"/(app)/(connected)/(app)/settings/(simple)/(pages)/opening-hours": [56,[2,5,6,11,12]],
		"/(app)/(connected)/(app)/settings/(simple)/(pages)/profile": [57,[2,5,6,11,12]],
		"/(app)/(connected)/(app)/settings/(simple)/(pages)/public": [58,[2,5,6,11,12]],
		"/(app)/(connected)/(app)/settings/(simple)/(pages)/referral": [59,[2,5,6,11,12]],
		"/(app)/(connected)/(app)/settings/ui": [67,[2,5,6]],
		"/(app)/(connected)/(app)/settings/widget": [68,[2,5,6]],
		"/(app)/(anonymous)/(t-c)/terms": [25,[2,3,4]],
		"/widget": [~90],
		"/widget/[hash]": [91,[18]],
		"/widget/[hash]/book/activity": [94,[18,19]],
		"/widget/[hash]/book/customer": [95,[18,19]],
		"/widget/[hash]/book/error": [96,[18,19]],
		"/widget/[hash]/book/hub": [97,[18,19]],
		"/widget/[hash]/book/offer": [98,[18,19]],
		"/widget/[hash]/book/pax": [99,[18,19]],
		"/widget/[hash]/book/payment": [100,[18,19]],
		"/widget/[hash]/book/price": [101,[18,19]],
		"/widget/[hash]/book/[bookingId]/payment-confirm": [92,[18,19]],
		"/widget/[hash]/book/[bookingId]/thank-you": [93,[18,19]],
		"/widget/[hash]/giftcards": [102,[18,20]],
		"/widget/[hash]/giftcards/check": [103,[18,20]],
		"/widget/[hash]/giftcards/pay-confirm/[id]": [105,[18,20]],
		"/widget/[hash]/giftcards/pay": [104,[18,20]],
		"/widget/[hash]/giftcards/recipients": [106,[18,20]],
		"/widget/[hash]/giftcards/select": [107,[18,20]],
		"/widget/[hash]/giftcards/send-date": [108,[18,20]],
		"/widget/[hash]/giftcards/sender": [109,[18,20]],
		"/widget/[hash]/inactive": [110,[18]],
		"/widget/[hash]/my-booking/[bookingId]": [111,[18,21]],
		"/widget/[hash]/my-booking/[bookingId]/pay/[paymentId]": [112,[18,21]],
		"/widget/[hash]/my-booking/[bookingId]/reconfirm": [113,[18,21]],
		"/widget/[hash]/my-booking/[bookingId]/survey": [114,[18,21]],
		"/widget/[hash]/terms": [115,[18]],
		"/widget/[hash]/welcome": [116,[18]]
	};

export const hooks = {
	handleError: (({ error }) => { console.error(error) }),
	
	reroute: (() => {}),
	transport: {}
};

export const decoders = Object.fromEntries(Object.entries(hooks.transport).map(([k, v]) => [k, v.decode]));

export const hash = false;

export const decode = (type, value) => decoders[type](value);

export { default as root } from '../root.js';